import React from "react";
import { IParagraphMembershipBenefitsProps } from "./ParagraphMembershipBenefitsProps";
import { Container } from "./ParagraphMembershipBenefitsHelpers";
import { graphql } from "gatsby";
import MembershipBenefits from "../../common/MembershipBenefits/MembershipBenefits";

const ParagraphMembershipBenefits: React.FC<
  IParagraphMembershipBenefitsProps
> = (props) => {
  return (
    <Container className="container-sm">
      <MembershipBenefits node={props.node} />
    </Container>
  );
};
export const fragment = graphql`
  fragment ParagraphMembershipBenefits on paragraph__membership_benefits {
    id
    parent_type
    field_title
    field_description
    field_subtitle
    field_link {
      title
      url
    }
    relationships {
      field_benefits {
        ... on paragraph__teaser_block {
          id
          field_description
          field_title
          field_link {
            title
            url
          }
          relationships {
            media: field_media {
              relationships {
                image: field_media_image {
                  publicUrl
                  gatsbyImage(width: 480, height: 288)
                }
              }
            }
          }
        }
      }
    }
  }
`;
export default ParagraphMembershipBenefits;
